/* CP Fitment — geteilte Helfer für Fahrzeug-Freigaben (Yido Teilegutachten)
 * Wird von cp-category.liquid genutzt; cp-fitment-finder und cp-product-fitment
 * bringen ihre eigene Kopie mit und bleiben davon unberührt.
 *
 * Datenformat von assets/cp-fitment.json:
 *   p = [[handle, titel], …]
 *   v = [[sku, groessenlabel, variant_id, produkt_index], …]   (nur freigegebene SKUs)
 *   f = { Marke: { Modell: [[generation, jahre, [v-index, …]], …] } }
 */
window.CPFitment = (function(){
  'use strict';

  var cache = null;

  /** Lädt die Fahrzeugdaten genau einmal und gibt immer dieselbe Promise zurück. */
  function load(url){
    if(!cache){
      cache = fetch(url, { credentials:'same-origin' })
        .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .catch(function(e){ cache = null; throw e; });
    }
    return cache;
  }

  /** Marke/Modell → URL-tauglicher Slug. Muss identisch zum Finder bleiben,
   *  sonst passen die Deep-Links zwischen Konfigurator und Kategorieseite nicht. */
  function slug(s){
    return String(s).replace(/Š/g,'S').replace(/š/g,'s').replace(/ß/g,'ss')
      .normalize('NFKD').replace(/[̀-ͯ]/g,'')
      .replace(/[^A-Za-z0-9]+/g,'-').replace(/^-|-$/g,'').toLowerCase();
  }

  /** Sortierschlüssel eines Größenlabels: erst Zoll, dann Breite.
   *  Verträgt Labels ohne ET wie "12x22 · CenterLock". */
  function sizeKey(label){
    var m = /(\d+(?:[.,]\d+)?)x(\d+)/.exec(label || '');
    if(!m) return [999, 999];
    return [parseFloat(m[2]), parseFloat(m[1].replace(',', '.'))];
  }

  function sortLabel(a, b){
    var ka = sizeKey(a), kb = sizeKey(b);
    return (ka[0] - kb[0]) || (ka[1] - kb[1]) || String(a).localeCompare(String(b), 'de');
  }

  /** Zoll aus einem Größenlabel ("9,5x20 ET18 · 5x112" → "20"). */
  function inch(label){
    var m = /x(\d{2})/.exec(label || '');
    return m ? m[1] : '';
  }

  /** Lochkreis aus einem Größenlabel (Teil hinter dem Mittelpunkt). */
  function bolt(label){
    var parts = String(label || '').split('·');
    return parts.length > 1 ? parts[parts.length - 1].trim() : '';
  }

  /** Marke aus einem Slug gegen die echten Datenschlüssel auflösen.
   *  Nötig, weil Tags (marke:mercedes) und Daten (Mercedes-Benz) auseinandergehen. */
  function resolveBrand(data, value){
    if(!data || !data.f || !value) return null;
    var keys = Object.keys(data.f), s = slug(value);
    for(var i = 0; i < keys.length; i++){ if(slug(keys[i]) === s) return keys[i]; }
    for(var j = 0; j < keys.length; j++){ if(slug(keys[j]).indexOf(s) === 0) return keys[j]; }
    return null;
  }

  function resolveModel(data, brand, value){
    if(!data || !data.f || !data.f[brand] || !value) return null;
    var keys = Object.keys(data.f[brand]), s = slug(value);
    for(var i = 0; i < keys.length; i++){ if(slug(keys[i]) === s) return keys[i]; }
    return null;
  }

  /** Alle freigegebenen SKUs eines Fahrzeugs, plus die getroffenen Generationen.
   *  Rückgabe: { skus: {sku:1}, rows: [{gen, years}], handles: {handle:1} } */
  function release(data, brand, model){
    var out = { skus:{}, rows:[], handles:{} };
    if(!data || !data.f || !data.f[brand] || !data.f[brand][model]) return out;
    var rows = data.f[brand][model];
    for(var r = 0; r < rows.length; r++){
      var gen = rows[r][0] || '', years = rows[r][1] || '', ids = rows[r][2] || [];
      if(gen || years) out.rows.push({ gen: gen, years: years });
      for(var i = 0; i < ids.length; i++){
        var v = data.v[ids[i]];
        if(!v) continue;
        out.skus[v[0]] = 1;
        var p = data.p[v[3]];
        if(p) out.handles[p[0]] = 1;
      }
    }
    return out;
  }

  /** Aus einer Variantenliste pro Größe genau einen Eintrag wählen:
   *  bevorzugt lieferbar, sonst der erste. Erwartet Objekte {label, available}. */
  function dedupeBySize(list){
    var by = {}, order = [];
    for(var i = 0; i < list.length; i++){
      var it = list[i];
      if(!by[it.label]){ by[it.label] = it; order.push(it.label); }
      else if(!by[it.label].available && it.available){ by[it.label] = it; }
    }
    order.sort(sortLabel);
    return order.map(function(l){ return by[l]; });
  }

  function formatPrice(cents){
    try {
      return new Intl.NumberFormat('de-DE', { style:'currency', currency:'EUR',
        minimumFractionDigits: (cents % 100 === 0) ? 0 : 2 }).format(cents / 100);
    } catch(e){
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  return {
    load: load, slug: slug, sizeKey: sizeKey, sortLabel: sortLabel,
    inch: inch, bolt: bolt, resolveBrand: resolveBrand, resolveModel: resolveModel,
    release: release, dedupeBySize: dedupeBySize, formatPrice: formatPrice
  };
})();
